<template>
  <form @submit="submit">

    <alert ref="alert"/>

    <div class="form-group form-material floating" data-plugin="formMaterial">
      <input
        v-model="email"
        type="email"
        class="form-control"
        v-bind:class="{'is-invalid': errors.email}"
        id="inputEmail"
        name="email"
        @keyup.enter="submit"
        @keyup="changeEmail">
      <div v-if="errors.email" class="invalid-feedback">{{ errors.email }}</div>
      <label class="floating-label" for="inputEmail">{{ _translate('lblEmail') }}</label>
    </div>
    <div class="form-group form-material floating" data-plugin="formMaterial">
      <input
        v-model="password"
        type="password"
        class="form-control"
        v-bind:class="{'is-invalid': errors.password}"
        id="inputPassword"
        name="password"
        @keyup.enter="submit">
      <div v-if="errors.password" class="invalid-feedback">{{ errors.password }}</div>
      <label class="floating-label" for="inputPassword">{{ _translate('lblPassword') }}</label>
    </div>
    <div class="form-group clearfix">
      <!--<div class="checkbox-custom checkbox-inline checkbox-primary float-left">-->
      <!--<input-->
      <!--v-model="rememberMe"-->
      <!--type="checkbox"-->
      <!--id="rememberMe"-->
      <!--name="rememberMe">-->
      <!--<label for="rememberMe">Remember me</label>-->
      <!--</div>-->

      <a class="float-right" href="#" @click="forgotClick">{{ _translate('txtForgotPassword') }} ?</a>
    </div>
    <button @click="submit" type="button" class="btn btn-primary btn-block btn-lg mt-40">{{ _translate('lblSignIn') }}</button>
  </form>

</template>

<script>
import { http }         from '@/http'
import qs               from 'query-string'
import alert            from '../alert'
import StaticTranslator from './../../../model/translator/StaticTranslator'

export default {
  components: { alert },
  data () {
    return {
      email:      '',
      password:   '',
      rememberMe: false,
      errors:     this.initErrors(),
      translator: new StaticTranslator()
    }
  },
  methods: {
    forgotClick (event) {
      event.preventDefault()
      this.$emit('forgotClick')
    },
    changeEmail () {
      this.$emit('changeEmail', this.email)
    },
    initErrors () {
      return {
        signInFailure: '',
        email:         '',
        password:      ''
      }
    },
    submit (event) {
      event.preventDefault()

      this.errors = this.initErrors()

      /*  validace */
      let hasError = false
      if (!this.email) {
        hasError          = true
        this.errors.email = 'Prosím zadejte email'
      }

      if (!this.password) {
        hasError             = true
        this.errors.password = 'Prosím zadejte heslo'
      }

      if (hasError) {
        return
      }

      let callback = (latitude, longitude) => {

        /* odeslani pozadavku */
        let data = {
          email:    this.email,
          password: this.password
        }

        if (latitude && longitude) {
          data.CurrentLatitude  = latitude
          data.CurrentLongitude = longitude
        }

        data.language = this.translator.language

        data = qs.stringify(data)
        http.post(
          `User/login`,
          data,
          {
            headers: {
              'Content-type': 'application/x-www-form-urlencoded'
            }
          }
        )
          /* zpracovani pozadavku */
            .then(response => {
              let expiration = {}
              if (this.rememberMe) {
                expiration = 31
              }

              this.$store.commit('setUser', { response: response.data.value, cookieExpiration: expiration })

              http.defaults.headers.appName       = this.$store.getters.urlAppName
              http.defaults.headers.Authorization = this.$store.getters.user.identity.tokenType + ' ' +
                this.$store.getters.user.identity.accessToken

              this.$router.push({ name: 'Dashboard' })

              document.body.classList.add('dashboard')

              this.cleanSingUp()
            })

            .catch(e => {
              if (e.response) {
                this.errors.signInFailure = e.response.data
                // this.errors.signInFailure = 'Přihlášení se nezdařilo.'
                //
                // if (e.response.data === 'Invalid User') {
                //   this.errors.signInFailure += ' Uživatel nebyl nalezen.'
                // }
                // if (e.response.data === 'Password is not Valid') {
                //   this.errors.signInFailure += ' Heslo není správné.'
                // }
              }
              else {
                this.errors.signInFailure = 'Přihlášení se nezdařilo'
              }

              this.$refs.alert.showMessage({ message: this.errors.signInFailure, type: 'error' })
            })
      }

      navigator.geolocation.getCurrentPosition((position) => {
        let latitude  = position.coords.latitude,
            longitude = position.coords.longitude

        callback(latitude, longitude)
      }, () => {
        callback(null, null)
      })
    },

    /**
     *
     * @param text
     * @return {*}
     * @private
     */
    _translate (text) {
      return this.translator.translate(text)
    }
  }
}
</script>
